export {FooterConnected as Footer} from './Footer.connect';
